import ResultTable from "../../components/table/ResultTable";
import ResultRow from "../../components/table/ResultRow";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../components/table/ResultBodyCell";
import HecRasHelper from "../../helpers/HecRasHelper";

// TUM reference layer'larda gizlenen genel KML metadata alanlari (gurultu).
// Gercek nitelikler (AADT, OBJECTID, POL_NAME1 ...) gorunur kalir.
const HIDDEN_KML_FIELDS = new Set([
    'timestamp', 'begin', 'end',
    'altitudemode', 'tessellate', 'extrude', 'visibility', 'draworder', 'icon',
]);

// Layer'a ozel, genel KML alanlarina EK olarak gizlenen alanlar.
const EXTRA_HIDDEN_BY_SLUG = {
    bridge_structures: new Set(['name', 'description']),   // 'id' gorunur kalir
    political: new Set(['id', 'name', 'description']),     // NC Political Areas
};

// NC FIRM Panel Effective description HTML'inden PANEL degerini (or. "0760") cikarir.
// description bir HTML tablo; once "PANEL" hucresinin yanindaki hucreyi, bulamazsa
// duz metinde "PANEL <deger>" desenini arar.
export const getPanelId = (description) => {
    if (!description) return null;
    try {
        const doc = new DOMParser().parseFromString(String(description), 'text/html');
        const cells = Array.from(doc.querySelectorAll('td, th'));
        for (let i = 0; i < cells.length - 1; i++) {
            if (cells[i].textContent.trim().toUpperCase() === 'PANEL') {
                const v = cells[i + 1].textContent.trim();
                if (v) return v;
            }
        }
        const text = doc.body ? doc.body.textContent || '' : '';
        const m = text.match(/PANEL[\s:]+([A-Za-z0-9]+)/i);
        if (m) return m[1];
    } catch (e) { /* parse hatasi -> null */ }
    return null;
};

// Tiklama popup'inda yalnizca description HTML'i (highlighted section) gosterilecek
// layer'lar.
export const DESCRIPTION_ONLY_SLUGS = new Set([
    'nc_firm',                 // NC FIRM Panel Effective
    'cb_2018_us_county_20m',   // US Counties Light
    'cb_2018_us_county_500k',  // US Counties HD
]);

// Hover'da gosterilecek ozel etiket (bilinen slug'lar icin); digerlerinde null.
export const getLayerHoverLabel = (slug, feature) => {
    const props = feature?.properties || {};
    if (slug === 'nc_firm') {
        return `PANEL ID: ${getPanelId(props.description) || '-'}`;
    }
    if (slug === 'cb_2018_us_county_20m' || slug === 'cb_2018_us_county_500k') {
        return `County: ${props.Name || props.name || '-'}`;
    }
    if (slug === 'political') {
        return (
            <table style={{borderCollapse: 'collapse'}}>
                <tbody>
                    <tr>
                        <td style={{paddingRight: 12}}>Political Area</td>
                        <td>{props.POL_NAME1 || '-'}</td>
                    </tr>
                    <tr>
                        <td style={{paddingRight: 12}}>CID</td>
                        <td>{props.CID || '-'}</td>
                    </tr>
                </tbody>
            </table>
        );
    }
    return null;
};

export default function ShapeItem({feature, slug}) {
    const properties = feature?.properties || {};

    // nc_firm / US Counties: yalnizca description (highlighted section) gosterilir.
    if (DESCRIPTION_ONLY_SLUGS.has(slug)) {
        return (
            <div dangerouslySetInnerHTML={{__html: properties.description || ''}}/>
        );
    }

    // Genel KML alanlarini her layer'da, ek layer-ozel alanlari ilgili slug'da gizle.
    const extra = EXTRA_HIDDEN_BY_SLUG[slug];
    const props = Object.keys(properties).filter(p => {
        const lower = p.toLowerCase();
        if (HIDDEN_KML_FIELDS.has(lower)) return false;
        if (extra && extra.has(lower)) return false;
        return true;
    });

    return (
        <>
            <ResultTable >
                {
                    props.map(prop => {
                        return (
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(30), textAlign: 'start', verticalAlign: 'start', fontWeight: 'bold'}}>
                                    {prop}
                                </ResultHeaderCell>
                                <ResultBodyCell style={{width: HecRasHelper.getWidth(75)}}>
                                    <div dangerouslySetInnerHTML={{__html: properties[prop]}}/>
                                </ResultBodyCell>
                            </ResultRow>
                        )
                    })
                }
            </ResultTable>
        </>
    )
}

export function ShapeTooltip({labels, feature}) {
    return (
        <ResultTable >
            {
                labels?.map((prop, idx) => {
                    return (
                        <ResultRow>
                            <ResultHeaderCell style={{width: HecRasHelper.getWidth(30), textAlign: 'start', verticalAlign: 'start', fontWeight: 'bold'}}>{prop}</ResultHeaderCell>
                            <ResultBodyCell style={{width: HecRasHelper.getWidth(75)}}>
                                <div dangerouslySetInnerHTML={{__html: feature?.properties[prop]}}/>
                            </ResultBodyCell>
                        </ResultRow>
                    )
                })
            }
        </ResultTable>
    )
}
